// Formats an amount as JMD money (Jamaican Dollar), e.g., "J$1,234.56"
export function formatMoney(value) {
  const n = Number(value) || 0;
  return `J$${n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
